module.exports = __webpack_public_path__ + "img/7.ee2854bd.webp";